<template>
  <div>
    <div class="canvas-box" id="myRadarChart"></div>
  </div>
</template>

<script>
export default {
  props: ["result", "score", "name1"],
  data() {
    return {
      colors: [
        {
          name: "工作倦怠",
          value: 1000,
          itemStyle: {
            color: "#6AC4EE",
            borderWidth: 3,
            borderColor: "#fff",
          },
        },
        {
          name: "情绪稳定",
          value: 1000,
          itemStyle: {
            color: "#EB766E",
            borderWidth: 3,
            borderColor: "#fff",
          },
        },
        {
          name: "积极心理",
          value: 1000,
          itemStyle: {
            color: "#F6B250",
            borderWidth: 3,
            borderColor: "#fff",
          },
        },
        {
          name: "心理症状",
          value: 1000,
          itemStyle: {
            color: "#A3D36C",
            borderWidth: 3,
            borderColor: "#fff",
          },
        },
        {
          name: "人际和谐",
          value: 1000,
          itemStyle: {
            color: "#8882E8",
            borderWidth: 3,
            borderColor: "#fff",
          },
        },
        {
          name: "适应耐挫",
          value: 1000,
          itemStyle: {
            color: "#8599A3",
            borderWidth: 3,
            borderColor: "#fff",
          },
        },
      ],
    };
  },
  mounted() {
    if (this.result.length > 0) {
      this.renderMap();
    }
  },
  watch: {
    result(val) {
      if (val.length > 0) {
        this.renderMap();
      }
    },
  },
  methods: {
    renderMap() {
      if (this.result.length > 0) {
        let myRadarChart = this.$echarts.init(
          document.getElementById("myRadarChart"),
          null,
          { renderer: "svg" }
        );
        // let indicators = new Array(5).fill({ max: 10 });
        let indicators = [];
        for (let i = 0; i < this.result.length; i++) {
          indicators.push({ max: 10 });
        }
        let seriesData = [];
        this.result.map((item, index) => {
          let c = Object.assign({}, this.colors[index]);
          c = Object.assign(c, { name: item.name });
          seriesData.push(c);
        });
        let startAngle = 30;
        let intv = 360 / this.result.length;
        startAngle = 90 - intv / 2;
        let option = {
          color: ["#69C5EF"],
          radar: {
            shape: "circle",
            indicator: indicators,
          },
          animation: false,
          series: [
            {
              type: "pie",
              startAngle: startAngle,
              radius: ["75%", "99.1%"],
              labelLine: {
                show: false,
              },
              label: {
                position: "inner",
                fontWeight: "bolder",
                color: "#fff",
                fontSize: 13,
              },
              data: seriesData,
            },
            {
              type: "radar",
              data: [
                {
                  value: this.score.reverse(),
                  name: "测试者标准分",
                  lineStyle: {
                    color: "#69C5EF",
                    type: "dashed",
                  },
                  label: {
                    show: true,
                    color: "#ff0000",
                  },
                  areaStyle: {
                    color: "#69C5EF",
                    opacity: 0.4, // 图形透明度
                  },
                },
                // {
                //   value: [9, 9, 9, 9, 9, 9],
                //   name: "群体平均分",
                //   lineStyle: {
                //     type: "dashed",
                //   },
                //   areaStyle: {
                //     color: "#FF917C",
                //     opacity: 0.2, // 图形透明度
                //   },
                // },
              ],
            },
          ],
        };
        myRadarChart.setOption(option);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.canvas-box {
  width: 460px;
  height: 480px;
  margin: 1px auto 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/dataView/echarts/latitudeRadar.vue